import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { WorkflowActionInputComponent } from "./workflow.action.input.component";
import { SystemActionComponent } from "./abstract.system.action.component";

@Component({
    standalone: true,
    selector: "s25-ng-workflow-assign-live25-draft-event-action",
    template: `
        <s25-ng-workflow-action-input
            class="system-input"
            [value]="inputMap()['useAssignmentPolicy']?.inputValue || 'false'"
            (valueChange)="setInputValue('useAssignmentPolicy', $event)"
            [label]="'Use Assignment Policy'"
            [type]="'checkbox'"
            [required]="false"
            [help]="
                'When checked, applies assignment policy (reservations needing approval will be filtered out). When unchecked, skips assignment policy and activates all assignments.'
            "
            [acceptedAnswerTypes]="acceptedFor('useAssignmentPolicy')"
        />
    `,
    styles: `
        .system-input {
            margin-bottom: 16px;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [WorkflowActionInputComponent],
})
export class AssignLive25DraftEventActionComponent extends SystemActionComponent {
    protected readonly actionCode = "ASSIGN_LIVE_25_DRAFT_EVENT";
}
